import { toast } from 'react-toastify';

import { ApiResponseType } from '../types/ApiResponseTypes';

const apiUrl = process.env.NEXT_PUBLIC_API_URL;

const upload = async (file: File, folder: string): Promise<ApiResponseType> => {
  let result;

  try {
    const session = localStorage.getItem('session') || '';

    const formData = new FormData();
    formData.append('file', file);

    const response = await fetch(`${apiUrl}/upload?folder=${folder}`, {
      method: 'POST',
      mode: 'cors',
      redirect: 'follow',
      credentials: 'include',
      headers: new Headers({
        ...(session && { session }),
      }),
      body: formData,
    });

    result = await response.json();
    if (result.errors?.length) {
      toast.error(result.errors[0].message);
    }
    return result;
  } catch (error) {
    toast.error(error);
    return result;
  }
};

export default upload;
